import { Component } from '@angular/core';
import { MotifModalRef } from '@ey-xd/ng-motif';

import { ErrorModalData } from 'src/app/utils/interfaces/error-modal.interface';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
    standalone: false
})
export class ErrorModalComponent {
  data: ErrorModalData | null = null;
  copied = false;

  constructor(private readonly modalRef: MotifModalRef<ErrorModalComponent>) {}

  close(): void {
    this.copied = false;
    this.modalRef.close();
  }

  async copy(): Promise<void> {
    if (!this.data?.correlationId) {
      return;
    }

    try {
      await navigator.clipboard.writeText(this.data.correlationId);
      this.copied = true;
    } catch {
      this.copyFallback(this.data.correlationId);
      this.copied = true;
    }
  }

  private copyFallback(value: string): void {
    const textarea = document.createElement('textarea');

    textarea.value = value;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    document.execCommand('copy');

    document.body.removeChild(textarea);
  }
}
